import { defaultProfile } from '../constants/franchiseManagement';
import { IBranch } from '~/types/branches';
import { ICurrency } from '~/types/currency';
import { TBooleanInNumber, TTranslate } from '~/types/main';
import { booleanToNumber } from '~/utils/helpers';

interface IResponseFranchiseProfileSettings {
  id: number;
  franchise_id: number;
  key: string;
  value: string;
  created_at: string | null;
  updated_at: string | null;
}
interface IResponseFranchiseProfile {
  id: number;
  title: string;
  branches: IBranch[];
  currency: ICurrency;
  settings: IResponseFranchiseProfileSettings[];
  certificate_name: string;
  certificate_url: string;
  taxable_delivery_fee: TBooleanInNumber;
  timezone: string;
  timezone_hour: string;
  vat: number;
  vat_included: TBooleanInNumber;
  vat_registration_number: string;
  created_at: string | null;
  updated_at: string | null;
  is_default?: TBooleanInNumber;
}

export const franchiseBranchCast = (branch: any) => ({
  id: Number(branch.id),
  name: (branch?.description?.branch_name || branch.name) as TTranslate,
  pos_service_id: String(branch.pos_service_id || branch.foodics_id || ''),
});

export const franchiseCast = (data: IResponseFranchiseProfile) => {
  return {
    id: Number(data.id),
    name: String(data.title),
    vat: String(data.vat || ''),
    vatIncluded: Number(data.vat_included || 0) as TBooleanInNumber,
    taxableDeliveryFee: Number(data.taxable_delivery_fee || 0) as TBooleanInNumber,
    vatRegistrationNumber: String(data.vat_registration_number || ''),
    certificateUrl: String(data.certificate_url || ''),
    certificateFilename: String(data.certificate_name || ''),
    certificate: new File([], ''),
    currencyId: String(data.currency?.id || ''),
    currencyCode: String(data.currency?.currency_code || ''),
    timezone: String(data.timezone || ''),
    branches: data.branches ? data.branches.filter((branch: any) => branch.status).map(franchiseBranchCast) : [],
    is_default: data.is_default ?? booleanToNumber(String(data.id) === defaultProfile.id),
  };
};

export type TFranchiseBranch = ReturnType<typeof franchiseBranchCast>;
export type TFranchise = ReturnType<typeof franchiseCast>;

export interface IFranchiseErrorMessages {
  vatRegNumber: string | null;
  vat: string | null;
  certificate: string | null;
}
